import React from "react";
import { UserRound, Stethoscope } from "lucide-react";
import { FOUNDERS, VISITING } from "../mock";

const initialsOf = (name) =>
  name
    .replace(/^(Dr\.|Mr\.|Mrs\.|Er\.|Ms\.)\s*/i, "")
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0])
    .join("");

const PersonCard = ({ p, highlight }) => (
  <div
    className={`group relative rounded-2xl p-7 text-center transition-all duration-500 hover:-translate-y-1.5 ${
      highlight
        ? "bg-gradient-to-b from-[#eaf1e6] to-[#fbf9f4] border border-[#c4a257]/40"
        : "bg-white border border-[#efe7d5]"
    } hover:shadow-[0_20px_50px_rgba(27,94,58,0.12)]`}
  >
    <div className="mx-auto w-20 h-20 rounded-full bg-[#1b5e3a] text-white flex items-center justify-center font-serif text-2xl mb-4 shadow-[0_8px_20px_rgba(27,94,58,0.25)]">
      {initialsOf(p.name)}
    </div>
    <h3 className="font-serif text-xl text-[#1b5e3a] leading-tight">{p.name}</h3>
    <p className="text-xs text-[#6b7568] mt-1 tracking-wide">{p.qual}</p>
    {p.role && (
      <div className="mt-4 inline-block px-3 py-1 rounded-full bg-[#1b5e3a]/8 text-[#1b5e3a] text-[11px] uppercase tracking-[0.18em] font-medium border border-[#1b5e3a]/15">
        {p.role}
      </div>
    )}
  </div>
);

const Team = () => {
  return (
    <section id="team" className="relative bg-[#fbf9f4] py-24 md:py-32">
      <div className="max-w-[1300px] mx-auto px-6 md:px-10">
        <div className="text-center mb-14">
          <div className="flex items-center justify-center gap-3 mb-5">
            <span className="h-px w-10 bg-[#c4a257]" />
            <span className="text-[#c4a257] text-xs tracking-[0.3em] uppercase font-medium">
              The People Behind Tatva
            </span>
            <span className="h-px w-10 bg-[#c4a257]" />
          </div>
          <h2 className="font-serif text-[38px] md:text-[54px] leading-tight text-[#1b5e3a]">
            Our <span className="italic text-[#2c7a4a]">Team</span>
          </h2>
        </div>

        <div className="flex items-center gap-4 mb-8">
          <UserRound className="w-5 h-5 text-[#1b5e3a]" />
          <h3 className="font-serif text-2xl text-[#1b5e3a]">
            Founders &amp; Co-Founders
          </h3>
          <span className="flex-1 h-px bg-[#efe7d5]" />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6 mb-16">
          {FOUNDERS.map((p) => (
            <PersonCard p={p} highlight key={p.name} />
          ))}
        </div>

        <div className="flex items-center gap-4 mb-8">
          <Stethoscope className="w-5 h-5 text-[#1b5e3a]" />
          <h3 className="font-serif text-2xl text-[#1b5e3a]">
            Visiting Consultation Doctors
          </h3>
          <span className="flex-1 h-px bg-[#efe7d5]" />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {VISITING.map((p) => (
            <PersonCard p={p} key={p.name} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Team;
